import { render, staticRenderFns } from "./OmniSearchModuleResult.vue?vue&type=template&id=5562edb4&scoped=true&"
import script from "./OmniSearchModuleResult.vue?vue&type=script&lang=js&"
export * from "./OmniSearchModuleResult.vue?vue&type=script&lang=js&"
import style0 from "./OmniSearchModuleResult.vue?vue&type=style&index=0&id=5562edb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5562edb4",
  null
  
)

export default component.exports